//   在http.js中引入axios
import axios from 'axios'   //引入 axios
import QS from 'qs'; // 引入qs模块，用来序列化post类型的数据，某些请求会用得到
import { Message } from 'element-ui'

let cancel = null;
// create an axios instance   创建axios实例
const service = axios.create({
    baseURL:process.env.NODE_ENV === "production" ? '' : "/bone",//在生产环境不需要代理
    //timeout: 10000, // request timeout  设置请求超时时间
    responseType: "",
    withCredentials: true, // 是否允许带cookie这些,
    headers: {
        "Content-Type": "application/json;charset=utf-8"
    },
    // headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded'
    // }
    transformRequest: {
        function(data, headers) {
            //直接formdata拼接发现在nodejs端获取不到发送的数据
            //multipart/form-data;charset=UTF-8
            if (headers['Content-Type'] == 'multipart/form-data;charset=UTF-8') {
                let formdata = new FormData();
                for (let key in data) {
                    formdata.append(key, data[key]);
                }
                return formdata;
            }
            return QS.stringify(data)
        }
    },
})

// http request 拦截器
// create an axios instance
service.interceptors.request.use(
    config => {
        //在获取历史报警的接口里面添加取消请求操作

        //暂时还没有登录校验
        // if (config.url != '/user/login') {
        //     let token = getToken();
        //     if (token) {
        //         config.headers['Authorization'] = token;
        //     } else {
        //         throw new axios.Cancel('取消停止播放请求');
        //     }
        // }
        // if(config.url == "/gethistoryalarmpic"){
        //     if(typeof cancel == 'function') {
        //         cancel('取消请求');
        //     }
        //     config['cancelToken'] = new axios.CancelToken(function(c){
        //         cancel = c;
        //     })
        // }
        return config;
    },
    error => {
        return Promise.reject(error);
    });

// http response 拦截器
// response interceptor
service.interceptors.response.use(
    response => {
        cancel = null;
        return Promise.resolve(response);
    },

    error => {
        cancel = null;
        // if(axios.isCancel(error)){
        //     console.log('取消上一个请求');
        //     return new Promise(() => {})
        // }
        let status = error?.response?.status;
        if (status) {
            switch (status) {
                case 206:
                case 301:
                case 302:
                case 400:
                case 401:
                case 403:
                case 404:
                case 416:
                case 418:
                    break;
                case 500:
                case 502:
                case 503:
                    Message({
                        message: '服务器出错!',
                        duration: 30 * 1000,
                        forbidClick: true,
                        showClose: true
                    });
                    // removeToken();
            }
        }
        return Promise.reject(error);
    });

export {
    service
}